"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParkingSelectedMarker = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _excluded = ["$hover", "$getDimensions", "$dimensionKey", "$geoService", "$onMouseAllow", "$prerender", "lat", "lng"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ParkingSelectedMarker = function ParkingSelectedMarker(_ref) {
  var $hover = _ref.$hover,
    $getDimensions = _ref.$getDimensions,
    $dimensionKey = _ref.$dimensionKey,
    $geoService = _ref.$geoService,
    $onMouseAllow = _ref.$onMouseAllow,
    $prerender = _ref.$prerender,
    lat = _ref.lat,
    lng = _ref.lng,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 38 42"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z",
    fill: "#0095E0",
    stroke: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.2153 11.5715H15.7917V22.7144H18.3194V19.0001H20.2153C22.307 19.0001 24.0069 17.3349 24.0069 15.2858C24.0069 13.2368 22.307 11.5715 20.2153 11.5715ZM20.3417 16.5239H18.3194V14.0477H20.3417C21.0368 14.0477 21.6055 14.6049 21.6055 15.2858C21.6055 15.9668 21.0368 16.5239 20.3417 16.5239Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "38",
    height: "42",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/_react.default.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};
exports.ParkingSelectedMarker = ParkingSelectedMarker;